module.exports = __webpack_public_path__ + "img/d6ef920.png";